import { firstValueFrom } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { AfterViewInit, Component, OnInit, ViewEncapsulation } from '@angular/core';;
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { LoginService } from './login-service/login.service';
import { LoggerService } from '../../shared/service/logger/logger.service';
import { AuthService } from '../../shared/service/auth/auth.service';
import { EchoService } from '../../shared/service/echo/echo.service';
import { Agencies } from '../../agencies.class';
import { AgentService } from '../../agent/agent-service/agent.service';
import * as config from 'app/app.config';
import { user_role, setAgentDefaultMoudule, getAgentDefaultMoudule, clearAppData, isSecureRiskAgent, getSessionData, showUnalteredDeactivateAgent, getReplaceUrl, getRouteArray } from 'app/util';
import { setSelectAgentsListInStorage } from 'app/agent/agent.utils';
import { Title } from '@angular/platform-browser';
import { cloneDeep } from 'lodash';
import { MfaService } from 'app/shared-modules/mfa-config-module/mfa.service';
import * as localService from 'app/local.service'
import * as handlingStorage from "app/handling-storage";
import { CookieService } from 'ngx-cookie-service';
import { interval, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

declare var $: any;
declare const window: any;

@Component({
  selector: 'ms-loginone-session',
  templateUrl: './loginone-component.html',
  styleUrls: ['./loginone-component.scss'],
  providers: [],
  encapsulation: ViewEncapsulation.None,
})
export class LoginoneComponent {

  user: any = {
    email: '',
    password: ''
  }
  agencies = Agencies.All
  agency;
  currentAgency$;
  loading = false;
  loginType = ['Insured', 'Agent']
  loginAs = "Agent"
  msg;
  errorMsg = false
  successMsg = false
  user_forget_password = { email: '' }
  user_reset_password = { newPassword: '', oldPassword: '', agent_id: '' }
  imlogin_debug = false;
  toggleimlogin: boolean = false;
  redirectUrl = ''
  displayScreenType = 'signin';
  displaySigninPassword = false;
  signInLoader = false;
  forgetPasswordLoader = false;
  is_confie = false;
  is_sso_enabled = false;
  mfa_payload: any = {}
  qr_payload: any = {
    type: "url"
  }
  unalteredDeactivateAgent = showUnalteredDeactivateAgent();
  verifyOTP = ''
  timeLeft: number = 600; // 10 minutes in seconds
  timerSubscription: Subscription | null = null;
  otpsend: boolean;
  authValue: any;
  authType: any;
  showResend: boolean = false;
  is_sunstarinsurance = false;
  subdomaion_for_sso = [
    'sunstarinsurance.insuredmine.com',
    'craneagency.insuredmine.com',
    'localhost:4300',
    'higusa.insuredmine.com',
    'qaagentportal.insuredmine.com',
    'gillman.insuredmine.com',
    'iwins.insuredmine.com',
    'regencyins.insuredmine.com',
    'weinsurellc.insuredmine.com',
    'weinsuregroup.insuredmine.com',
    "weinsuregroup103.insuredmine.com",
    "weinsuregroup104.insuredmine.com",
    "weinsuregroup105.insuredmine.com",
    "weinsuregroup106.insuredmine.com",
    "weinsuregroup107.insuredmine.com",
    "weinsuregroup109.insuredmine.com",
    "weinsuregroup110.insuredmine.com",
    "weinsuregroup111.insuredmine.com",
    "weinsuregroup112.insuredmine.com",
    "weinsuregroup113.insuredmine.com",
    "weinsuregroup114.insuredmine.com",
    "weinsuregroup115.insuredmine.com",
    "weinsuregroup117.insuredmine.com",
    "weinsuregroup119.insuredmine.com",
    "weinsuregroup120.insuredmine.com",
    "weinsuregroup122.insuredmine.com",
    "weinsuregroup124.insuredmine.com",
    "weinsuregroup125.insuredmine.com",
    "weinsuregroup126.insuredmine.com",
    "weinsuregroup127.insuredmine.com",
    "weinsuregroup130.insuredmine.com",
    "weinsuregroup131.insuredmine.com",
    "weinsuregroup132.insuredmine.com",
    "weinsuregroup133.insuredmine.com",
    "weinsuregroup135.insuredmine.com",
    "weinsuregroup137.insuredmine.com",
    "weinsuregroup138.insuredmine.com",
    "weinsuregroup139.insuredmine.com",
    "weinsuregroup142.insuredmine.com",
    "weinsuregroup147.insuredmine.com",
    "weinsuregroup148.insuredmine.com",
    "weinsuregroup149.insuredmine.com",
    "weinsuregroup151.insuredmine.com",
    "weinsuregroup152.insuredmine.com",
    "weinsuregroup155.insuredmine.com",
    "weinsuregroup162.insuredmine.com",
    "weinsuregroup164.insuredmine.com",
    "weinsuregroup165.insuredmine.com",
    "weinsuregroup167.insuredmine.com",
    "weinsuregroup169.insuredmine.com",
    "weinsuregroup170.insuredmine.com",
    "weinsuregroup172.insuredmine.com",
    "weinsuregroup173.insuredmine.com",
    "weinsuregroup175.insuredmine.com",
    "weinsuregroup177.insuredmine.com",
    "weinsuregroup181.insuredmine.com",
    "weinsuregroup185.insuredmine.com",
    "weinsuregroup191.insuredmine.com",
    "weinsuregroup192.insuredmine.com",
    "weinsuregroup193.insuredmine.com",
    "weinsuregroup200.insuredmine.com",
    "weinsuregroup202.insuredmine.com",
    "weinsuregroup203.insuredmine.com",
    "weinsuregroup210.insuredmine.com",
    "weinsuregroup214.insuredmine.com",
    "weinsuregroup219.insuredmine.com",
    "weinsuregroup222.insuredmine.com",
    "weinsuregroup223.insuredmine.com",
    "weinsuregroup227.insuredmine.com",
    "weinsuregroup237.insuredmine.com",
    "weinsuregroup239.insuredmine.com",
    "weinsuregroup240.insuredmine.com",
    "weinsuregroup241.insuredmine.com",
    "weinsuregroup243.insuredmine.com",
    "weinsuregroup245.insuredmine.com",
    "weinsuregroup247.insuredmine.com",
    "weinsuregroup249.insuredmine.com",
    "weinsuregroup251.insuredmine.com",
    "weinsuregroup256.insuredmine.com",
    "weinsuregroup257.insuredmine.com",
    "weinsuregroup261.insuredmine.com",
    "weinsuregroup263.insuredmine.com",
    "weinsuregroup270.insuredmine.com",
    "weinsuregroup271.insuredmine.com",
    "weinsuregroup277.insuredmine.com",
    "weinsuregroup280.insuredmine.com",
    "weinsuregroup283.insuredmine.com",
    "weinsuregroup295.insuredmine.com",
    "weinsuregroup302.insuredmine.com",
    "weinsuregroup303.insuredmine.com",
    "weinsuregroup308.insuredmine.com",
    "weinsuregroup316.insuredmine.com",
    "weinsuregroup318.insuredmine.com",
    "weinsuregroup319.insuredmine.com",
    "weinsuregroup321.insuredmine.com",
    "weinsuregroup330.insuredmine.com",
    "weinsuregroup337.insuredmine.com",
    "weinsuregroup338.insuredmine.com",
    "weinsuregroup343.insuredmine.com",
    "weinsuregroup345.insuredmine.com",
    "weinsuregroup347.insuredmine.com",
    "weinsuregroup348.insuredmine.com",
    "weinsuregroup372.insuredmine.com",
    "weinsuregroup375.insuredmine.com",
    "weinsuregroup450.insuredmine.com",
    "weinsuregroup453.insuredmine.com",
    "weinsuregroup455.insuredmine.com",
    "weinsuregroup457.insuredmine.com",
    "weinsuregroup460.insuredmine.com",
    "weinsuregroup108.insuredmine.com",
    "weinsuregroup146.insuredmine.com",
    "weinsuregroup153.insuredmine.com",
    "weinsuregroup156.insuredmine.com",
    "weinsuregroup157.insuredmine.com",
    "weinsuregroup159.insuredmine.com",
    "weinsuregroup160.insuredmine.com",
    "weinsuregroup161.insuredmine.com",
    "weinsuregroup201.insuredmine.com",
    "weinsuregroup216.insuredmine.com",
    "weinsuregroup221.insuredmine.com",
    "weinsuregroup229.insuredmine.com",
    "weinsuregroup236.insuredmine.com",
    "weinsuregroup238.insuredmine.com",
    "weinsuregroup242.insuredmine.com",
    "weinsuregroup244.insuredmine.com",
    "weinsuregroup248.insuredmine.com",
    "weinsuregroup250.insuredmine.com",
    "weinsuregroup258.insuredmine.com",
    "weinsuregroup265.insuredmine.com",
    "weinsuregroup269.insuredmine.com",
    "weinsuregroup272.insuredmine.com",
    "weinsuregroup276.insuredmine.com",
    "weinsuregroup279.insuredmine.com",
    "weinsuregroup286.insuredmine.com",
    "weinsuregroup291.insuredmine.com",
    "weinsuregroup298.insuredmine.com",
    "weinsuregroup306.insuredmine.com",
    "weinsuregroup310.insuredmine.com",
    "weinsuregroup312.insuredmine.com",
    "weinsuregroup314.insuredmine.com",
    "weinsuregroup326.insuredmine.com",
    "weinsuregroup327.insuredmine.com",
    "weinsuregroup331.insuredmine.com",
    "weinsuregroup336.insuredmine.com",
    "weinsuregroup339.insuredmine.com",
    "weinsuregroup363.insuredmine.com",
    "weinsuregroup366.insuredmine.com",
    "weinsuregroup456.insuredmine.com",
    "weinsuregroup462.insuredmine.com",
    "weinsuregroup463.insuredmine.com",
    "weinsuregroup467.insuredmine.com"
  ]
  constructor(
    private route: Router,
    private loginService: LoginService,
    private agentService: AgentService,
    private logger: LoggerService,
    private echo: EchoService,
    private auth: AuthService,
    private activeRoute: ActivatedRoute,

    private titleService: Title,
    private mfaService: MfaService,
    private cookieService: CookieService,
  ) {
    
  }

  ngOnInit(): void {
      this.route.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(event => {
      const arr = ['/get-started', '/get-started/loginone'];
      if (event && event['url'] && (event['url'] == arr[0] || event['url'] == arr[1])) {
        const m = 'get-started', n = 'setup'
        this.route.navigate(["/" + m, n])
      }
    })
    if (this.subdomaion_for_sso.includes(window.location.host)) {
      this.is_sso_enabled = true;
    }
    if (window.location.host == 'sunstarinsurance.insuredmine.com'){
      this.is_sunstarinsurance = true
    }
    this.cookieService.deleteAll('/agent');
    console.log('LoginoneComponent');
    this.titleService.setTitle('Login | InsuredMine');

    let self = this;

    let query_params = this.activeRoute.snapshot.queryParams;
    console.log("query_params: ", query_params);
    if (query_params.ssologin == 'true') {
      if (query_params.success == 'false') {
        this.echo.err("SSO Login failed")
      }
      else {
        let token = query_params.token;
        this.loginAction({ token })
      }
    }

  }
  showModal(id) {
    $("#" + id).modal('show')
  }

  changeScreen(type = undefined) {
    if (type) {
      this.displayScreenType = type;
      if (this.displayScreenType == 'signin') {
        this.signInLoader = false
        this.resetOtpState()
      }
      if (this.displayScreenType == 'forget_password') {
        this.user_forget_password.email = this.user.email
        this.validateEmail(this.user_forget_password.email)
      }

    }
  }

  changeLoginAs() {
    setTimeout(() => {
      if (this.loginAs == 'Insured') {
        this.loading = true;
        window.location.href = this.agency.homePageUrl + "/user/"
      }
    }, 50);
  }
  async submitForgetPasswordForm() {
    this.successMsg = false;
    this.errorMsg = false;
    this.msg = ""

    try {
      this.forgetPasswordLoader = true;
      let res = await firstValueFrom(this.loginService.forgetPassword(this.user_forget_password))
      this.forgetPasswordLoader = false;
      this.successMsg = true;
      this.errorMsg = false;
      this.user_forget_password = { email: '' };
      this.msg = "We have sent you a link to reset your password. Please check your email."
      this.displayScreenType = 'forget_password_success';
    } catch (err) {
      this.forgetPasswordLoader = false;
      this.successMsg = false;
      this.errorMsg = true;
      this.msg = err.error && err.error.message ? err.error.message : "Something went wrong, Please try again later"
    }
  }

  async login() {
    this.logger.log("login clicked")
    this.redirectUrl = getSessionData('redirectUrl')
    localService.clearToken()
    sessionStorage.clear()
    // clearAppData()

    // console.log(this.user);
    if (this.user.email != '' && this.user.password != '') {
      this.logger.log("login submitted: ", this.user)

      setTimeout(async () => {
        this.signInLoader = true;
        let payload = cloneDeep(this.user)
        payload.subdomain = window.location.origin;
        if (this.verifyOTP) {
          payload["otp"] = this.verifyOTP
        }
        try {
          let res: any = await this.loginService.login(payload)
          if (res && res.hasOwnProperty("mfa_verification_required")) {
            if (this.showResend) {
              this.echo.succ("OTP send successfully!")
            }
            if (res.mfa_verification_required) {
              if (res.mfa_configuration && res.mfa_configuration.mfa_action) {
                this.authValue = res.mfa_configuration.mfa_action
                this.authType = res.mfa_configuration.mfaMethod
              }
              this.displayScreenType = "OTPVerifyScreen"
              this.showResend = false
              this.startTimer()
              return
            }
          }
          this.signInLoader = false;

          if (res.hasOwnProperty("MFASetUpRequired")) {
            if (res.MFASetUpRequired) {
              this.displayScreenType = "qr_code_screen"
              this.qr_payload.value = res.otpauth_url
            }
            else if (!res.MFASetUpRequired) {
              this.mfa_payload.agentId = res.agent
              this.displayScreenType = "mfa_token_screen"
              setTimeout(() => {
                document.getElementById("mfa-token-input").click()
              }, 200);
            }
          }
          else {
            this.resetOtpState()
            this.loginAction(res)
          }

        } catch (error) {
          // this.resetOtpState()
          console.log("login error", error);
          this.logger.log("login err: ", error)
          if (error && error.message == 'Invalid or expired OTP.') {
            this.otpsend = false;
            this.verifyOTP = '';
            this.timeLeft = 0; // Reset timer to 10 minutes
            this.showResend = true
            if (this.timerSubscription) {
              this.timerSubscription.unsubscribe();
            }
          }
          this.signInLoader = false;
          this.echo.err(error.message)
        }
      }, 300);
    }
    else {
      this.echo.err("Fill email and password correctly")
    }
  }

  loginAction(res) {

    this.auth.injectScripts()

    this.loading = true;
    try {
      this.logger.log("login res: ", res)
      this.auth.setParentToken(res.token)
      this.auth.setChildToken(res.token)
      this.auth.setLoginStatus("true");

      // console.log("193 isUserLoggedin - ", this.auth.isUserLoggedin())
      this.auth.setHeaderType("default");
      this.auth.setAddHeader(true)

      this.agentService.getAgentProfile(async (agent) => {

        this.logger.log("after login getAgentProfile")
        let agency = agent.agency_id;
        if (agency.version) {
          sessionStorage.setItem("version", agency.version);
        }

        if (agent && agent.isMsAccountConnected) {
          sessionStorage.setItem("isMsAccountConnected", agent.isMsAccountConnected);
        }
        localService.setJsonValue("parentAgentId", agent._id)
        localService.setJsonValue("childAgentId", agent._id)
        localService.setJsonValue("defaultPortalView", agent.defaultView)
        localService.setJsonValue("parentAgentProfile", agent)
        localService.setJsonValue("childAgentProfile", agent)

        let payloadDeactivate: any = {
          agency_id: handlingStorage.getAgencyId()
        }
        this.unalteredDeactivateAgent = showUnalteredDeactivateAgent();
        if (this.unalteredDeactivateAgent) {
          payloadDeactivate.deactivated = true;
        }
        else {
          payloadDeactivate.archived = true;
        }

        await firstValueFrom(this.agentService.getAllAgentsUnderAgency(payloadDeactivate));
        if(agency.restricted_pipelines_for_stage_change){
          localService.setJsonValue('restricted_pipelines_for_stage_change', agency.restricted_pipelines_for_stage_change)
        }
        if (agent.agency_id.timezone.date_format.toLowerCase() == 'mm-dd-yyyy') {
          localService.setJsonValue("agency_date_format", "MM/dd/yyyy")
        }
        if (agent.agency_id.timezone.date_format.toLowerCase() == 'dd-mm-yyyy') {
          localService.setJsonValue("agency_date_format", "dd/MM/yyyy")
        }

        config.timezone.date_format = agent.agency_id.timezone.date_format

        localService.setJsonValue("parentAgentEmail", agent.email); //Set Item for Tracking
        localService.setJsonValue("agentEmail", agent.email); //Set Item for Tracking
        localService.setJsonValue('agencyType', agent.agency_id.premium_feature.use_as_ams)
        setAgentDefaultMoudule(agent.defaultLandingPage)
        config.setCountryCode(agent.agency_id.country_code)
        if (!localService.getJsonValue('agency_date_format')) {
          localService.setJsonValue("agency_date_format", 'MM/dd/yyyy')
        }
        config.timezone.date_format = localService.getJsonValue('agency_date_format')

        if (!localService.getJsonValue('use_as_ams')) {
          if (agent.agency_id.premium_feature.use_as_ams) localService.setJsonValue("use_as_ams", agent.agency_id.premium_feature.use_as_ams)
        }

        if (agent.management_role) { //
          localService.setJsonValue("parentManagementRole", agent.management_role)
          localService.setJsonValue("childManagementRole", agent.management_role)
        }
        if (agent.has_admin_access) { //
          localService.setJsonValue("has_admin_access", agent.has_admin_access)
        }
        //cleanup code
        if (agent.twilioNumber && agent.twilioNumber != '') {
          localService.setJsonValue("twilioNumber", agent.twilioNumber)
        }
        if (agent.mailClient) {
          localService.setJsonValue("mailClient", agent.mailClient)
        }

        localService.setJsonValue("role", agent.defaultView);
        // if(agent.role == 'agent' || agent.role == 'manager') localService.setJsonValue("role", 'agent')

        if (agent.role == user_role.csr) {
          setSelectAgentsListInStorage(agent.access_agents)
          localService.setJsonValue("role", user_role.csr);
        }
        if (agent.role == user_role.admin) {
          localService.setJsonValue("role", user_role.admin);
          // localService.setJsonValue("defaultDealboard", deal_board.sharable)
        }
        localService.setJsonValue("version", config.version)
        localService.setJsonValue("version", config.version)

        this.logger.log("after localstorage setup")


        //if (which == "sso") {
        // setTimeout(() => {
        //   this.loading = false;
        // }, 15000)
        //}

        if(agent.allAgencyData){
          await firstValueFrom(this.agentService.getAllAgentsInAgency())
        }

        setTimeout(() => {
          let default_page = getAgentDefaultMoudule()


          if (this.redirectUrl) {
            let p = this.redirectUrl.replace(getReplaceUrl(), '')
            if (p == '/' || p == '') {
              p = default_page
            }
            let data = getRouteArray(p)
            if (data.queryParams) {
              this.route.navigate(data.routes, { queryParams: data.queryParams })
            }
            else {
              this.route.navigate(data.routes)
            }
          }
          else {
            if (agent.firstLogin) {
              localService.setJsonValue("firstLogin", agent.firstLogin)
              this.route.navigate(['get-started'])
            }
            else {
              this.route.navigate([default_page])
            }
          }
        }, 200);
      });
    } catch (error) {
      this.logger.log("login err: ", error)
      this.loading = false;
      this.echo.err(error.message)
    }


  }
  // reconfigMfa(){
  //   let payload = {
  //     agentId: this.mfa_payload.agentId
  //   }
  //   this.loading = true;
  //   this.mfaService.reconfigMfa(payload).subscribe(
  //     (res:any)=>{
  //       // console.log("res: ", res);
  //       this.displayScreenType = 'qr_code_screen'
  //       this.loading = false;
  //       this.qr_payload.value = res.otpauth_url
  //     },
  //     err=>{
  //       this.loading = false;
  //       // console.log("error: ", err);
  //       if(err.status == 401){
  //         this.echo.err("Invalid Token")
  //       }
  //     }
  //   )
  // }

  submitMfaTokenForm() {
    this.mfa_payload.loading = true;
    this.mfaService.submitToken(this.mfa_payload).subscribe(
      res => {
        // console.log("res: ", res);
        this.mfa_payload.loading = false;
        this.loginAction(res)
      },
      err => {
        this.mfa_payload.loading = false;
        // console.log("error: ", err);
        if (err.status == 401) {
          this.echo.err("Invalid Token")
        }
      }
    )
  }
  bookmark() {
    alert('Please press CTRL+D (or Command+D for Macs) to bookmark this page.')
  }

  isSsoRequiredForthishostname() {
    //let ssodomain= ['gwictest.insuredmine.com','gwic.insuredmine.com'];
    let ssodomain = ['gwicfetest.insuredmine.com', 'gwicfe.insuredmine.com', 'localhost', 'qaagentportal.insuredmine.com'];
    let flag = ssodomain.find((item) => {
      return item == window.location.hostname;
    });
    return flag;
  }
  shouldDisplayIMLogin() {
    let flag = this.isSsoRequiredForthishostname();
    return flag ? { 'display': 'none' } : { 'display': 'block' };
    /*
    if(this.toggleimlogin){
      return { 'display': 'block' };
    }
    else{
      return { 'display': 'none' };
    }
    */
    //return { 'display': 'none' };
  }
  shouldDisplaySsoLogin() {
    let flag = this.isSsoRequiredForthishostname();
    return flag ? { 'display': 'block' } : { 'display': 'none' };
    //return { 'display': 'block' };
  }

  async onLoginWith0365() {
    try {
      let retval = await window.signIn("loginPopup");
      localService.setJsonValue("isazuresso", "true");
      this.loginAction({ token: retval.accessToken });
    }
    catch (err) {
      console.log("ng-onLoginWith0365 err ", err);
    }
  }
  loading_sso = false;
  async onLoginWithSSO() {
    console.log("onLoginWithSSO");

    try {
      window.location.href = window.location.origin + "/auth/one-login-test/qa-portal"
    }
    catch (err) {
    }
  }

  forget_email_valid = false;

  validateEmail(email) {
    console.log("email: ", email);
    email = email.trim()
    // var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

    // if (reg.test(email) == false) {
    //   this.forget_email_valid = false;
    // }
    // else {
    // }
    this.forget_email_valid = true;

    console.log("this.forget_email_valid: ", this.forget_email_valid);

  }
  onKey(event: any) {

    console.log("event.target.value;", event.target.value)
    this.validateEmail(event.target.value);
  }
  startTimer() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
    if (this.timeLeft == 0) {
      this.timeLeft = 600
    }
    this.timerSubscription = interval(1000)
      .pipe(take(this.timeLeft))
      .subscribe(
        () => {
          this.timeLeft--;
        },
        (err) => {
          console.error('Timer error:', err);
        },
        () => {
          this.timeLeft = 0; // Mark timer as expired
          console.log('Timer expired');
          this.showResend = true
          this.otpsend = false
          this.verifyOTP = ''
        }
      );
  }
  verifySendOTP() {
    if (this.verifyOTP.trim() == '' || !this.verifyOTP) {
      this.echo.err("Please enter valid otp to verify!")
      return
    }
    this.otpsend = true
    this.login()
  }
  resetOtpState() {
    this.otpsend = false;
    this.verifyOTP = '';
    this.timeLeft = 600; // Reset timer to 10 minutes
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }
  // Helper method to get the time in mm:ss format
  getTimeLeft() {
    const minutes = Math.floor(this.timeLeft / 60);
    const seconds = this.timeLeft % 60;
    return `${this.pad(minutes)}:${this.pad(seconds)}`;
  }

  // Helper method to pad single digits to two digits
  pad(value: number) {
    return value < 10 ? `0${value}` : value;
  }
  resendOtp() {
    this.verifyOTP = ''
    this.login()
  }
}
